import { defaultData, options } from "../config/charts/CalculatorOptions";
import { getAportes, getAportesDetalle } from "../../services/calculators";

import { Doughnut } from "react-chartjs-2";
import Modal from "../common/Modal";
import React from "react";
import { convertToMoney } from "../../utils/number";
import { useAPIs } from "../../apis/APIsConfig";
import { useState } from "react";
import { useEffect } from "react";
import { colors } from "../config/charts/colors";
import { maxNumber } from "../../services/utils";

export function Aportes({ ...props }) {
  useAPIs();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    calculate(+props.formState.data.salario);
  }, []);

  function calculate(salario) {
    if (salario !== undefined) {
      getAportes(salario).then((res) => {
        props.setData(res.data.value);
        getAportesDetalle(salario).then((resDetalle) => {
          props.setDataDetalle(resDetalle.data.value);

          const data = { ...defaultData };
          data.labels = resDetalle.data.value.map((rd) => rd.concepto);
          data.datasets[0].data = resDetalle.data.value.map((rd) => rd.pct);
          props.setChartData(data);
        });
      });
    }
  }

  function disableButton() {
    return !props.formState.data.salario;
  }

  return (
    <div className="w-full max-w-[1120px] pt-14">
      <form
        className="max-w-[544px] pb-8"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="form-group">
          <label>Ingresa tu Salario</label>
          <div className="input-group-append">
            <input
              type="number"
              className="form-control large"
              placeholder="RD$ 0.00"
              value={props.formState.data.salario}
              onChange={props.changeHandler("salario")}
              pattern="[0-9]*"
              onKeyPress={maxNumber(9)}
            />
            <button
              type="button"
              onClick={() => calculate(+props.formState.data.salario)}
              disabled={disableButton()}
            >
              Calcular
            </button>
          </div>
        </div>
      </form>
      <div className="block space-y-6 md:space-y-8">
        <div className="w-full shadow-box bg-neutral-white rounded-lg border border-gray-10 pt-7 md:pt-8 pb-4 md:pb-6 pl-4 md:pl-6 pr-4 md:pr-8">
          <div className="flex items-center justify-between border-b border-gray-5 pb-4 mb-6">
            <h5 className="lead text-gray-70 font-semibold pr-2">
              Distribución de Aportes
            </h5>
            <button
              onClick={() => setIsOpen(true)}
              className="btn-icon btn-secondary btn-small md:btn-medium"
            >
              <i className="icon icon-info text-[14px] md:text-[20px]"></i>
            </button>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 xlg:grid-cols-3 gap-4">
            <div className="info-card active">
              <p>
                Total de aportes (
                {convertToMoney(
                  props.data.pctEmpleador + props.data.pctAfiliado
                )}
                %)
              </p>
              <h4>
                RD${" "}
                {convertToMoney(
                  props.data.aporteEmpleador + props.data.aporteAfiliado
                )}
              </h4>
            </div>
            <div className="info-card">
              <p>
                Tu empleador aporta ({convertToMoney(props.data.pctEmpleador)}%)
              </p>
              <h4>RD$ {convertToMoney(props.data.aporteEmpleador)}</h4>
            </div>
            <div className="info-card">
              <p>Tu aportas ({convertToMoney(props.data.pctAfiliado)}%)</p>
              <h4>RD$ {convertToMoney(props.data.aporteAfiliado)}</h4>
            </div>
          </div>
        </div>

        <div className="w-full shadow-box bg-neutral-white rounded-lg border border-gray-10 p-6">
          <div className="block border-b border-gray-5 pb-4 mb-6">
            <h5 className="lead text-gray-70 font-semibold pr-2">
              Composición de Aportes
            </h5>
          </div>
          <div className="block xlg:flex">
            <div className="rounded-lg bg-gray-5 min-w-full xlg:min-w-[320px] h-[288px]">
              <Doughnut
                width={200}
                height={200}
                data={props.chartData}
                options={options}
                className="p-4 md:p-8"
              />
            </div>
            <div className="w-full block pt-10 xlg:pt-0 pl-0 xlg:pl-10">
              <ul className="block space-y-6 pb-6">
                {props.dataDetalle.map((item, index) => (
                  <li className="description-graphic" key={index}>
                    <div className="block lg:flex items-center justify-between">
                      <p className="text-body-1 text-gray-80 font-body font-normal ">
                        <span
                          style={{
                            backgroundColor: colors[index],
                            marginRight: "5px",
                          }}
                        >
                          &nbsp;&nbsp;
                        </span>
                        {item.concepto}{" "}
                        <b className="font-semibold">
                          ({convertToMoney(item.pct)}%)
                        </b>
                      </p>
                      <p className="text-body-1 text-gray-80 font-body font-semibold">
                        RD$ {convertToMoney(item.montoAporte)}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="block lg:flex items-center justify-between bg-gray-5 rounded p-2">
                <p className="text-body-1 text-gray-70 font-body font-normal ">
                  Totales{" "}
                  <b className="font-semibold">
                    (
                    {convertToMoney(
                      props.dataDetalle
                        .map((dd) => dd.pct)
                        .reduce((partialSum, a) => partialSum + a, 0)
                    )}
                    %)
                  </b>
                </p>
                <p className="text-body-1 text-gray-80 font-body font-semibold">
                  RD${" "}
                  {convertToMoney(
                    props.dataDetalle
                      .map((dd) => dd.montoAporte)
                      .reduce((partialSum, a) => partialSum + a, 0)
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Información Salarial"
        show={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="info-card">
          <p>Salario Mínimo Nacional</p>
          <h5>RD$ {convertToMoney(props.data.salarioMinimo)}</h5>
        </div>
        <div className="info-card">
          <p>No. Cotizaciones Salario Mínimo Nacional</p>
          <h5>{props.data.cantidadCotizacion}</h5>
        </div>
        <div className="info-card">
          <p>El Salario Máximo Cotizable</p>
          <h5>RD$ {convertToMoney(props.data.salarioMaximo)}</h5>
        </div>
      </Modal>
    </div>
  );
}
